import { useDispatch } from "react-redux"
import { showToast } from "../../commonComponents/showToast";
import { useForm } from "../../hooks"
import * as ActionTypes from '../actions/actionTypes'


export const useHeaderContainer = (containerKey) => {

    const dispatch = useDispatch();
    const { isLoading, saveForm, deleteForm } = useForm(containerKey)

    const addItem = async () => {
        try {
            const response = await saveForm({ transportation: { containers: [{ id: '' }] } })
            if (response?.responseCode == '200') {
                dispatch({
                    type: ActionTypes.ADD_HEADER_CONTAINER,
                    payload: response?.responseMessage,
                })
            }
        } catch (e) { console.error(e) }
    }

    const updateItem = async (id, payload) => {
        dispatch({
            type: ActionTypes.UPDATE_HEADER_CONTAINER,
            id,
            payload
        })
    }

    const saveItem = async (payload) => {
        console.log("saveItem payload__", payload)
        try {
            const response = await saveForm({ transportation: { containers: [{ ...payload }] } }, false)
            console.log("save response__", response)
        } catch (e) { console.error(e) }
    }

    const deleteItem = async (id) => {
        try {
            const response = await deleteForm({
                shipmentId: window.shipmentId,
                transportation: { containers: [{ id: id, type: 'SELLER' }] }
            })
            if (response?.responseCode == '200')
                dispatch({ type: ActionTypes.DELETE_HEADER_CONTAINER, id })
            else
                showToast('Something went wrong, cannot delete lineItem')
        } catch (e) { console.error('err_', e) }
    }

    return [isLoading, addItem, updateItem, saveItem, deleteItem]
}